<p-table #racklist [columns]="cols" [value]="racks" [lazy]="true" (onLazyLoad)="loadRacksLazy($event)" [paginator]="true"
         [rows]="20" [totalRecords]="totalRecords" [loading]="loading">
  <ng-template pTemplate="caption" [style]="{'height':'30px !important'}">
    <div style="height: 30px; width: 100%">
      <span class="float-left">Rack List</span>
      <div class="float-right">
        <input pInputText type="text" (keypress)="handleSearchKey($event, racklist)" placeholder="Search" [style]="{'margin-right':'15px'}" />
        <a (click)="loadRacksLazy(null)" class="text-white iconbutton" title="Refresh List"><i class="fa fa-refresh" [ngClass]="{'fa-spin':loading}"></i></a>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th pSortableColumn="SerialNumber">Serial <p-sortIcon field="SerialNumber"></p-sortIcon></th>
      <th pSortableColumn="RackTypeName">Rack Type <p-sortIcon field="RackTypeName"></p-sortIcon></th>
      <th pSortableColumn="DepartmentName">Department <p-sortIcon field="DepartmentName"></p-sortIcon></th>
      <th >Samples </th>
      <th pSortableColumn="IsRackFull">Is Full <p-sortIcon field="IsRackFull"></p-sortIcon></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-columns="cols">
    <tr>
      <td>
        <a [routerLink]="['/resolve-rack-unload',row.SerialNumber]">{{row.SerialNumber}}</a>
      </td>
      <td>{{row.RackTypeName}}</td>
      <td>{{row.DepartmentName}}</td>
      <td>{{row.SampleCount}}</td>
      <td>{{row.IsRackFull}}</td>
    </tr>
    <tr *ngIf="row['showDetail'] == true" [@inOutAnimation]>
      <td colspan="10" style="background-color: lightgray; padding: 15px">
        <app-receiving-package searchTerm="{{searchTerm}}" packageId="{{row['Id']}}"></app-receiving-package>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-toast></p-toast>
